module.exports = __webpack_public_path__ + "q.no2.aa900744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/q.no2.jpg
// module id = s1dl
// module chunks = 0